export const TRAINING_HOME = '/training-resources?section=training';
export const TRAINING_TABS = [['paths', 'Learning paths'], ['manufacturers', 'Manufacturers & floor plans'], ['lenders', 'Lenders'], ['marketing', 'Marketing'], ['practice', 'Practice'], ['plan', 'Start my day'], ['resources', 'Training resources']];
export const workspaceHref = (view, extra = '') => `${TRAINING_HOME}&workspace=${encodeURIComponent(view)}${extra}`;
export const courseHref = (id, lessonId) => `${TRAINING_HOME}&course=${encodeURIComponent(id)}${lessonId ? `&lesson=${encodeURIComponent(lessonId)}` : ''}`;

// Keep existing bookmarks and lesson links, but give them one home in the hub.
export function legacyAcademyDestination(search, courseId = '', hash = '') {
  const old = new URLSearchParams(search);
  const property = !courseId && old.get('workspace') === 'resources' && old.get('resource') !== 'learning';
  const params = new URLSearchParams({ section: property ? 'property' : 'training' });
  old.forEach((value, key) => { if (key !== 'section') params.append(key, value); });
  if (property) {
    params.delete('workspace');
    if (!params.get('resource')) params.set('resource', 'start');
  } else if (old.get('workspace') === 'resources') params.delete('resource');
  if (courseId) { params.set('course', courseId); params.delete('workspace'); }
  return `/training-resources?${params.toString()}${hash}`;
}
